import urls from 'urls';
import evite from 'evite';
import SearchModel from '../models/search_model';

const [DOWN_ARROW_KEY, UP_ARROW_KEY, ENTER_KEY] = [40, 38, 13];
const { addClass, appendChild, createElement, hasClass, hide, removeClass, removeChildren, toggle, } = evite.dom;
const { assertString } = evite;
import { parseParams } from '~/common/utils';

export default class SearchComponent {
  hovering = false;
  isAnimating = false;

  constructor(options) {
    this.model = options.model || new SearchModel({'urlName': options.urlName});
    this.model.urlName =  assertString(options.urlName);

    this.queryParamName = options.queryParamName || '';
    this.el = evite.assert(options.el);
    this.form = evite.assert(options.form);
    this.searchInput = evite.assert(options.searchInput);
    this.submitButton = options.submitButton || createElement('<button class="search-submit-button" />');
    this.suggestionList = options.suggestionList || createElement('<ul class="search-ul" />');
    this.searchLocationElement = options.searchLocationInput || createElement('<input name="search_location" />');
    this.preventDropdown = !options.suggestionList;

    this.select = _.debounce(this.select.bind(this), 100, {leading: true, trailling: false });
    this.focus = _.debounce(this.focus.bind(this), 100, {leading: true, trailling: false });

    // TODO - remove ignore submit
    this.ignoreSubmit = options.ignoreSubmit;
    this.submitModel = options.submitModel? options.submitModel.bind(this): null;
    this.enableSuggestionTitles = Boolean(options.enableSuggestionTitles);

    if (!this.enableSuggestionTitles) {
      addClass(this.el, 'no-search-titles');
    }
    hide(this.suggestionList);
    removeChildren(this.suggestionList);
    addClass(this.el, 'initialized');

    this.bindEvents();

    if(this.searchTerm){
      this.search(this.searchTerm);
    }

    if(this.queryParamName){
      evite.history.addEventListener('change', this.handleHistoryChange);
    }
  }

  bindEvents() {
    this.searchInput.addEventListener('focus', this.focus);
    this.searchInput.addEventListener('blur', this.blur);
    this.searchInput.addEventListener('keydown', this.handleSearchKeyDown);
    this.searchInput.addEventListener('keyup', this.handleSearchKeyUp);
    this.searchInput.addEventListener('input', this.handleSearchInput);
    this.form.addEventListener('submit', (e) => e.preventDefault());
    this.suggestionList.addEventListener('mouseover', this.turnOnHovering);
    this.suggestionList.addEventListener('mouseleave', this.turnOffHovering);
    this.submitButton.addEventListener('click', this.handleSubmitButtonClick);
  };

  submitSuggestionElement = (event, element) => {
    const isNoMatches = element && hasClass(element, 'no-matches');
    if (isNoMatches) { return; }

    let id = element.dataset.id;
    let type =
      element.dataset.category? SearchModel.TYPE_CATEGORY:
      element.dataset.suggestions? SearchModel.TYPE_SUGGESTION:
      element.dataset.hints? SearchModel.TYPE_HINT:
      '';
    let model = this.model.findWhere({id, type});
    if(!model) {
      evite.error(`Cannot find model by id:${id} type:${type}`);
    } else {
      this.searchTerm = model.type === SearchModel.TYPE_HINT?
        model.id:
        model.text;

      if (this.submitModel) {
        if (this.submitModel(model) === false) {
          event.preventDefault();
        }
      }
    }

    this.blur();
  };

  submit() {
    this.form.submit();
  }

  focus = () => {
    addClass(this.el, 'active');
    addClass(this.submitButton, 'active');
    addClass(this.suggestionList, 'active');
    addClass(this.searchInput, 'active');

    this.invalidateDropdownbox();
    this.select();
  };

  blur = () => {
    if (!this.hovering) {
      hide(this.suggestionList);
      removeClass(this.el, 'active');
      removeClass(this.submitButton, 'active');
      removeClass(this.suggestionList, 'active');
      removeClass(this.searchInput, 'active');
    }
  };

  select(){
    this.searchInput.select();
  }

  scrollElementIntoView = async (element) => {
    if (!element) { return; }

    let previousSibling = element.previousSibling;
    if (previousSibling && hasClass(previousSibling, 'title')) {
      element = previousSibling;
    }

    let currentPosition = element.offsetTop;

    const isEmpty = !this.suggestionList.firstChild;
    if (isEmpty || this.suggestionList.scrollTop === currentPosition) {
      return;
    }

    this.isAnimating = true;

    // TODO - investigate removing jQuery here
    const jQuery = await evite.when('jquery');
    this.$suggestionList = this.$suggestionList || jQuery(this.suggestionList);
    this.$suggestionList.animate({ scrollTop: currentPosition, }, 50);

    if (this.timeoutId) { clearTimeout(this.timeoutId); }
    this.timeoutId = setTimeout(() => { this.isAnimating = false; }, 200);
  };

  invalidateDropdownbox() {
    if (this.preventDropdown || !this.searchTerm) {
      hide(this.suggestionList);
      return;
    }

    const isNoMatches = hasClass(this.suggestionList.firstChild, 'no-matches');
    const isCurrentSearch = this.currentSearch === this.searchTerm;

    if(!isCurrentSearch && isNoMatches) {
      hide(this.suggestionList);
    }

    this.search(this.searchTerm);
  };

  async search(searchTerm){
    const model = this.model;
    this.currentSearch = searchTerm;
    const json = await this.model.fetch(searchTerm);

    if (this.currentSearch === json.search) {
      await this.model.sync(json);
      const categoryListItems = this.createListItems({
        title: 'Invitation Categories',
        dataName: 'category',
        className: 'category',
        collection: model.categoryCollection,
      });
      const suggestionListItems = this.createListItems({
        title: 'Suggestions',
        dataName: 'suggestions',
        className: 'suggestion',
        collection: model.suggestionCollection,
      });
      const hintListItems = this.createListItems({
        title: 'Keywords',
        dataName: 'hints',
        className: 'hint',
        collection: model.hintCollection,
      });

      this.renderListItems({
        categoryListItems,
        suggestionListItems,
        hintListItems
      });

    }

    if(!hasClass(this.el, 'active') && document.activeElement === this.searchInput){
      addClass(this.el, 'active');
      addClass(this.submitButton, 'active');
      addClass(this.suggestionList, 'active');
      addClass(this.searchInput, 'active');

      this.invalidateDropdownbox();
    }

    toggle(this.suggestionList, hasClass(this.el, 'active') && Boolean(this.suggestionList.firstChild));
  }

  renderListItems({ categoryListItems, suggestionListItems, hintListItems }) {
    const suggestionList = this.suggestionList;
    this.removeListItem(suggestionList);

    const dropDownListItems = []
      .concat(categoryListItems)
      .concat(suggestionListItems)
      .concat(hintListItems);

    if (dropDownListItems.length) {
      this.appendListItems(suggestionList, dropDownListItems);
      return;
    }

    let listItem = createElement(`<li class="search-li no-matches">No matches</li>`);
    appendChild(this.suggestionList, listItem);
  }

  removeListItem(suggestionList) {
    let listItem;
    while(listItem = suggestionList.lastChild) {
      if (hasClass(listItem, 'entry')) {
        listItem.removeEventListener('click', this.handleSuggestionClick);
      }
      listItem.removeEventListener('mouseover', this.handleSuggestionMouseOver);

      suggestionList.removeChild(listItem);
    }
  }

  appendListItems(suggestionList, dropDownListItems) {
    for(let i = 0; i < dropDownListItems.length; ++i) {
      let listItem = dropDownListItems[i];
      if (hasClass(listItem, 'entry')) {
        listItem.addEventListener('click', this.handleSuggestionClick);
      }
      listItem.addEventListener('mouseover', this.handleSuggestionMouseOver);

      appendChild(suggestionList, listItem);
    }
  }

  createListItems({ title, dataName, className, collection }) {
    let listItems = [];
    if (collection && collection.length) {

      if (this.enableSuggestionTitles) {
        const listItem = evite.dom.createElement(
          `<li class="search-li ${className} title" role="heading">${title}</li>`
        );
        listItems.push(listItem);
      }

      for(let i = 0; i < collection.length; ++i) {
        const model = collection[i];
        const {text, id} = model;
        // TODO - remove data-${dataName}
        const listItem = evite.dom.createElement(
          `<li class="search-li ${className} entry" data-id="${id}" data-${dataName}="${id}" role="option">${text}</li>`
        );

        const isFirst = !i;
        if (isFirst) {
          addClass(listItem, 'first-of-entry-group');
        }

        const isLast = i === collection.length - 1;
        if (isLast) {
          addClass(listItem, 'last-of-entry-group');
        }

        listItems.push(listItem);
      }
    }

    return listItems;
  }

  turnOnHovering = () => {
    this.hovering = true;
  };

  turnOffHovering = () => {
    this.hovering = false;
  };

  handleSubmitButtonClick = (event) => {
    event.preventDefault();
    this.submit();
    this.blur();
    return false;
  };

  handleSuggestionClick = (event) => {
    event.preventDefault();
    this.hovering = false;
    this.submitSuggestionElement(event, event.target);
    return false;
  };

  handleSuggestionMouseOver = (event) => {
    let entryElement = event.target;
    while(entryElement && !hasClass(entryElement, 'entry')) {
      entryElement = entryElement.nextSibling;
    }

    if (!this.isAnimating) {
      this.selectedElement = entryElement;
    }
  };

  handleSearchKeyDown = (event) => {
    if (event.keyCode === DOWN_ARROW_KEY || event.keyCode === UP_ARROW_KEY) {
      event.preventDefault();
      this.select();
      return false;
    }
  };

  handleSearchKeyUp = (event) => {
    switch(event.keyCode) {
      case ENTER_KEY:
        return void this.handleEnterKey(event);
      case DOWN_ARROW_KEY:
        return void this.handleDownArrowKey(event);
      case UP_ARROW_KEY:
        return void this.handleUpArrowKey(event);
    }
  };

  handleSearchInput = (event) => {
    this.invalidateDropdownbox();
  };

  handleEnterKey(event) {
    if (this.selectedElement) {
      this.submitSuggestionElement(event, this.selectedElement);
    }
    else if (!this.ignoreSubmit) {
      this.submit();
    }
  }

  handleDownArrowKey(event) {
    let selectedElement = this.selectedElement;
    let nextSibling = selectedElement && selectedElement.nextSibling;
    let nextEntry = nextSibling;
    while(nextEntry && !hasClass(nextEntry, 'entry')) {
      nextEntry = nextEntry.nextSibling;
    }

    let { firstChild } = this.suggestionList;
    let firstEntry = firstChild;
    while(firstEntry && !hasClass(firstEntry, 'entry')) {
      firstEntry = firstEntry.nextSibling;
    }

    let newSelectedElement = nextEntry || firstEntry;
    if (newSelectedElement) {
      this.selectedElement = newSelectedElement;
    }

    this.scrollElementIntoView(this.selectedElement);
  }

  handleUpArrowKey(event) {
    let selectedElement = this.selectedElement;
    let previousSibling = selectedElement && selectedElement.previousSibling;
    let previousEntry = previousSibling;
    while(previousEntry && !hasClass(previousEntry, 'entry')) {
      previousEntry = previousEntry.previousSibling;
    }

    let { lastChild } = this.suggestionList;
    let lastEntry = lastChild;
    while(lastEntry && !hasClass(lastEntry, 'entry')) {
      lastEntry = lastEntry.previousSibling;
    }

    let newSelectedElement = previousEntry || lastEntry;
    if (newSelectedElement) {
      this.selectedElement = newSelectedElement;
    }

    this.scrollElementIntoView(this.selectedElement);
  }

  handleHistoryChange = (event) => {
    const params = parseParams(location.search.slice(1));
    this.searchTerm = params[this.queryParamName] || '';
  };

  get searchTerm() {
    return SearchModel.normalizeSearch(this.searchInput.value || '');
  }
  set searchTerm(str) { this.searchInput.value = str || ''; }

  get selectedElement() { return this.el.querySelector('.selected'); }
  set selectedElement(element) {
    let selectedElement = this.selectedElement;

    if (selectedElement && selectedElement !== element) {
      removeClass(selectedElement, 'selected');
    }

    if (element && selectedElement !== element) {
      addClass(element, 'selected');
    }
  }

  get searchLocation() {
    return this.searchLocationElement && this.searchLocationElement.value || '';
  }
}

SearchComponent.factory = function (id) {
  if (!id) {
    return (
      Array.from(document.querySelectorAll('.search-component:not(.initialized), .suggestion-search:not(.initialized)'))
        .map((el) => {
          let id = el.getAttribute('id');

          if (!id) {
            id = evite.guid('search-component');
            el.setAttribute('id', id);
          }

          return SearchComponent.factory(id);
        })
    );
  }

  let el = document.getElementById(id);
  let searchInput = el && el.querySelector('input[type="search"]');

  if (!el || !searchInput) {
    return null;
  }

  let form = el.querySelector('form');
  let suggestionList = el.querySelector('ul');
  let searchLocationInput = el.querySelector('[name="search_location"]');
  let searchIcon = el.querySelector('.search-icon');
  let submitButton = el.querySelector('.submit-button') || el.querySelector('[type="submit"]') || searchIcon;

  // TODO - reduce repeated code / remove id reference
  if (id === 'event_search_box') {
    return new SearchComponent({
      el,
      form,
      searchInput,
      submitButton,
      suggestionList,
      searchLocationInput,
      ignoreSubmit: true,
      enableSuggestionTitles: true,
      urlName: 'ajax_event_suggestions',
      submitModel(model) {
        let {type, id} = model;
        if (type !== 'suggestion') {
          return false;
        }
        window.location = urls.get('view', { event_id: id });
      }
    });
  }

  return new SearchComponent({
    el,
    form,
    searchInput,
    submitButton,
    suggestionList,
    searchLocationInput,
    ignoreSubmit: false,
    enableSuggestionTitles: true,
    queryParamName: 'query',
    urlName: 'ajax_gallery_suggestions',
    submitModel(model) {
      if (model.type === 'category') {
        let category = model.id;
        let { searchLocation, searchTerm } = this;

        let baseUrl = urls.get('gallery/category', { category });
        window.location = `${baseUrl}?search_location=${searchLocation}&query=${searchTerm}`;

        return false;
      }
      this.submit();
    }
  });
};

evite.when('block body').then(SearchComponent.factory);
evite.when('block footer').then(SearchComponent.factory);



// WEBPACK FOOTER //
// ./assets/es6/common/components/search.es6